@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.countriesSelectLabel {
  color: v.$white-color;
  @include t.text(10px, 120%, "bold");
  letter-spacing: 0.6px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.countriesSelectLoader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 100%;
  padding: 13px 16px;
  border-radius: 8px;
  border: 1px solid v.$gray-border-color;
  background: v.$navy-color;
  color: v.$gray-light-color;
  @include t.text(14px, 22px, "normal");
  flex: 1;
}

.countriesSelect {
  flex: 1;
  width: 100%;
}

.countriesLabelWrapper {
  display: flex;
}

.countriesSelectInputWrapper {
  display: flex;
  position: relative;
}

.openListIcon {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.3s ease-in-out;
}

.openListIconActive {
  transform: rotate(180deg) translateY(50%);
}

.errorMessage {
  bottom: -22px;
}